import React from 'react';

export default function Header() {
    return ( <header className=''>
        <div className='container mt-md-3'>
            <div className='d-flex d-flex justify-content-between'>
                <div className=''>
                    <a href='https://public.cssresearch.org'>
                        <picture>
                            <img alt='Center for the Study of Services Logo (CSS)' className='header__logo' src='/assets/img/public/login/MHQP-lg.png' />
                        </picture>                    
                    </a>
                </div>
                <div className=''>
                    <a href='https://public.cssresearch.org'>
                        <picture>
                            <img alt='Center for the Study of Services Logo (CSS)' className='header__logo' src='/assets/img/public/login/logo-dark.png' />
                        </picture>                    
                    </a>
                </div>                
            </div>
        </div>
    </header>);
}